import React, { useContext, useEffect, useState } from 'react';
import {
    MenuItem,
    Select,
    Checkbox,
    ListItemText,
} from "@mui/material";
import { useAuth } from '../../../context/API_Client';
import { customToast } from '../../../reusableComponents/customToaster/customToast';
import { colorBrandObject } from '../../../../constants/brandings';
import MonthYearPicker from "../../../reusableComponents/MonthYearPicker/MonthYearPicker";
import { generateDateTimezone } from '../../utils/utils';
import Filter from './Filter';
import GenericReconContext from '../../../context/genericRecon.context';
import { useParams } from 'react-router-dom';
import CustomButton from '../../../reusableComponents/CustomButton';
import FileDownload from "../../../../assets/svg/fileDownload.svg";

const checkBoxStyle = {
    "& .MuiSvgIcon-root": {
        color: colorBrandObject?.secondaryButtonColor,
    },
    "&.Mui-checked": {
        color: colorBrandObject?.secondaryButtonColor,
        "& .MuiSvgIcon-root": {
            fill: colorBrandObject?.secondaryButtonColor,
        },
    },
};

const FilterHeader = ({ downloadAction, buttonLoader, triggerCapture, entityName }) => {
    const { reconId } = useParams();
    const {
        selectedTags,
        setSelectedTags,
        startDate,
        setStartDate,
        endDate,
        setEndDate
    } = useContext(GenericReconContext)
    const { getReconciliationTags } = useAuth();
    const [tags, setTags] = useState([]);

    useEffect(() => {
        getReconciliationTags(
            reconId,
            (tags) => {
                // setLoader(false);
                if (typeof tags == "object" && tags?.length) {
                    const cleanedArray = tags.filter(value => typeof value === "string" && value.trim() !== "");
                    cleanedArray.sort();
                    setTags(cleanedArray);
                } else {
                    setTags([]);
                }
            },
            (err) => {
                customToast("error", "high", err);
            })
    }, [reconId]);

    const handleTagChange = (event) => {
        let value = event.target.value;
        const isSelectingAll = value[value.length - 1] === "all";
        if (isSelectingAll) {
            const allSelected = selectedTags.length === tags.length;
            setSelectedTags(allSelected ? [] : [...tags]);
            value = allSelected ? [] : [...tags];
        } else {
            setSelectedTags(value);
        }
    };

    const handleDateChange = (date, type) => {
        if (type == "start") {
            if (!date) return setStartDate(null);
            const formattedDate = generateDateTimezone(type, date);
            setStartDate(formattedDate);
            setEndDate(null);
        } else {
            if (!date) return setEndDate(null);
            const formattedDate = generateDateTimezone(type, date);
            setEndDate(formattedDate);
        }
    };

    const isAllTagsSelected = (tags.length > 0 && selectedTags.length === tags.length);

    return (
        <div className='d-flex align-items-start justify-content-between mb-4'>
            <div>
                <Filter entityName={entityName} />
            </div>
            <div className='recon-kpi-dropdowns d-flex'>
                {tags?.length > 0 &&
                    <div>
                        <Select
                            sx={{ width: '250px' }}
                            multiple
                            value={selectedTags}
                            onChange={handleTagChange}
                            displayEmpty
                            required // Makes it required
                            MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
                            renderValue={(tag) => (
                                <>
                                    {tag.length > 0
                                        ? tag.map((value) => tags.find((item) => item === value)).join(", ")
                                        : "All"
                                    }
                                </>
                            )}
                        >
                            {tags?.length > 0 && (
                                <MenuItem
                                    value="all"
                                    className="businessUnit businessUnitCheckbox"
                                    style={{ padding: "5px 10px", height: "40px" }}
                                >
                                    <Checkbox
                                        sx={checkBoxStyle}
                                        checked={isAllTagsSelected}
                                        indeterminate={
                                            selectedTags.length > 0 && selectedTags.length < tags.length
                                        }
                                    />
                                    <div className="ellipsisListItem" style={{ paddingLeft: "6px" }}>
                                        <ListItemText primary="All" />
                                    </div>
                                </MenuItem>
                            )}

                            {tags?.length > 0 ? (
                                tags.map((option) => (
                                    <MenuItem
                                        key={option}
                                        value={option}
                                        className="businessUnit businessUnitCheckbox"
                                        style={{ padding: "5px 10px", height: "40px" }}
                                    >
                                        <Checkbox
                                            sx={checkBoxStyle}
                                            checked={selectedTags.indexOf(option) > -1}
                                        />
                                        <div className="ellipsisListItem" style={{ paddingLeft: "6px" }}>
                                            <ListItemText primary={option} />
                                        </div>
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>
                                    <ListItemText primary="No options available" />
                                </MenuItem>
                            )}
                        </Select>
                    </div>
                }
                <MonthYearPicker
                    placeholder="Start Month"
                    minDate="2023-01-01"
                    disableFuture={true}
                    isClearDate={true}
                    value={startDate}
                    onChange={(date) => handleDateChange(date, "start")}
                    style={{ width: '150px' }}
                />

                <MonthYearPicker
                    placeholder="End Month"
                    minDate={startDate}
                    disableFuture={true}
                    isClearDate={true}
                    // disabled={!startDate}
                    value={endDate}
                    onChange={(date) => handleDateChange(date, "end")}
                    style={{ width: '150px' }}
                />
                <div className='exclude-from-screenshot'>

                    <CustomButton
                        text={<FileDownload />}
                        sx={{ padding: "0", width: "43px", height: "40px" }}
                        onClick={downloadAction}
                        loading={buttonLoader}
                        color={"primary"}

                    />

                </div>
            </div>
        </div>
    )
}

export default FilterHeader